import module from 'recursoshumanos/module.js'
import template from './template.html'

export class RecursoshumanosReportesIncapacidadesExportarComponent {
  idEmpresa
  fechaInicial
  fechaFinal
  onClose

  constructor (RecursoshumanosReportesIncapacidadesService) {
    this.RecursoshumanosReportesIncapacidadesService = RecursoshumanosReportesIncapacidadesService
  }

  exportar () {
    if (this.exportando) return

    this.exportando = true

    this.RecursoshumanosReportesIncapacidadesService.get(this.idEmpresa, this.fechaInicial, this.fechaFinal, 'xls')
      .then((response) => (this.resultado = response))
      .finally(() => this.exportando = false)
  }

  guardar () {
    this.resultado.data.save()
  }

  cerrar () {
    this.onClose()
  }
}

module.component('recursoshumanosReportesIncapacidadesExportar', {
  controller: RecursoshumanosReportesIncapacidadesExportarComponent,
  template,
  bindings: {
    idEmpresa: '<',
    fechaInicial: '<',
    fechaFinal: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/recursoshumanos/components/reportes/incapacidades/exportar/component.js